import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RouterQuery } from '@datorama/akita-ng-router-store';
import { ComponentController } from '@lycoris-nubila/ngx-lycoris';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import indexOf from 'lodash-es/indexOf';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { CoachSettingsState, CoachSettingsStore } from './coach-settings.store';

@Injectable()
@UntilDestroy()
export class CoachSettingsController extends ComponentController<CoachSettingsState> {
	public activeTabIndex$: Observable<number>;
	private tabIndexes = ['general', 'biography', 'calendar'];

	constructor(
		store: CoachSettingsStore,
		private _routerQuery: RouterQuery,
		private _router: Router
	) {
		super(store);

		this._initObservables();
		this._initListeners();
	}

	public updateActiveTabIndex(index: number): void {
		this._router.navigate(['/settings/coach', 'tab', this.tabIndexes[index]], {
			replaceUrl: true,
		});
		this.store.update({ activeTabIndex: index });
	}

	private _initObservables() {
		this.activeTabIndex$ = this.select('activeTabIndex');
	}

	private _initListeners() {
		this._routerQuery
			.selectParams<string>('tab')
			.pipe(
				map((tab) => Math.max(indexOf(this.tabIndexes, tab), 0)),
				tap((index) => this.store.update({ activeTabIndex: index })),
				untilDestroyed(this)
			)
			.subscribe();
	}
}
